import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from './../../assets/logo.svg'
import _imports_1 from './../../assets/CarenuityLogoTransparent.png'


const _hoisted_1 = { class: "sidebar-wrapper" }
const _hoisted_2 = { class: "sidebar-header" }
const _hoisted_3 = {
  key: 0,
  alt: "Carenuity logo",
  src: _imports_0,
  class: "logo-img"
}
const _hoisted_4 = {
  key: 1,
  alt: "Carenuity logo",
  src: _imports_1,
  class: "logo-img logo-collapsed"
}
const _hoisted_5 = ["title"]
const _hoisted_6 = { class: "sidebar-nav" }
const _hoisted_7 = { class: "nav-list" }
const _hoisted_8 = { class: "nav-item" }
const _hoisted_9 = { class: "nav-item" }
const _hoisted_10 = { class: "nav-item" }
const _hoisted_11 = { class: "nav-item" }
const _hoisted_12 = { class: "external-links" }
const _hoisted_13 = {
  href: "https://solutions.carenuity.com",
  target: "_blank",
  rel: "noopener noreferrer",
  class: "external-link",
  title: "Solution Builder"
}
const _hoisted_14 = {
  key: 0,
  class: "external-text"
}
const _hoisted_15 = {
  href: "https://carenuity.com/home-challenge/",
  target: "_blank",
  rel: "noopener noreferrer",
  class: "external-link",
  title: "Home Challenge"
}
const _hoisted_16 = {
  key: 0,
  class: "external-text"
}
const _hoisted_17 = { class: "sidebar-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_user_profile_dropdown = _resolveComponent("user-profile-dropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.mobileMenuOpen)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "sidebar-overlay",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeMobileMenu && _ctx.closeMobileMenu(...args)))
        }))
      : _createCommentVNode("", true),
    _createElementVNode("aside", {
      class: _normalizeClass(["sidebar", { open: _ctx.mobileMenuOpen, collapsed: _ctx.sidebarCollapsed }])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_router_link, {
          to: "/dashboard",
          class: "logo-link",
          onClick: _ctx.closeMobileMenu
        }, {
          default: _withCtx(() => [
            (!_ctx.sidebarCollapsed)
              ? (_openBlock(), _createElementBlock("img", _hoisted_3))
              : (_openBlock(), _createElementBlock("img", _hoisted_4))
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createElementVNode("button", {
          class: "collapse-toggle-header",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleSidebarCollapse && _ctx.toggleSidebarCollapse(...args))),
          title: _ctx.sidebarCollapsed ? 'Expand Sidebar' : 'Collapse Sidebar'
        }, [
          (_openBlock(), _createElementBlock("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            class: _normalizeClass(["collapse-icon", { rotated: _ctx.sidebarCollapsed }])
          }, [...(_cache[3] || (_cache[3] = [
            _createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M11 19l-7-7 7-7m8 14l-7-7 7-7"
            }, null, -1)
          ]))], 2))
        ], 8, _hoisted_5)
      ]),
      _createElementVNode("nav", _hoisted_6, [
        _createElementVNode("ul", _hoisted_7, [
          _createElementVNode("li", _hoisted_8, [
            _createVNode(_component_router_link, {
              to: "/dashboard",
              class: "nav-link",
              "active-class": "active",
              onClick: _ctx.closeMobileMenu
            }, {
              default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                _createElementVNode("svg", {
                  xmlns: "http://www.w3.org/2000/svg",
                  viewBox: "0 0 24 24",
                  fill: "currentColor",
                  class: "nav-icon"
                }, [
                  _createElementVNode("path", { d: "M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8V11h-8v10zm0-18v6h8V3h-8z" })
                ], -1),
                _createElementVNode("span", { class: "nav-text" }, "Dashboard", -1)
              ]))]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _createElementVNode("li", _hoisted_9, [
            _createVNode(_component_router_link, {
              to: "/alarms",
              class: "nav-link",
              "active-class": "active",
              onClick: _ctx.closeMobileMenu
            }, {
              default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                _createElementVNode("svg", {
                  xmlns: "http://www.w3.org/2000/svg",
                  viewBox: "0 0 24 24",
                  fill: "currentColor",
                  class: "nav-icon"
                }, [
                  _createElementVNode("path", { d: "M12 22c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2zm6-6v-5c0-3.07-1.63-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.64 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2zm-2 1H8v-6c0-2.48 1.51-4.5 4-4.5s4 2.02 4 4.5v6z" })
                ], -1),
                _createElementVNode("span", { class: "nav-text" }, "Alarms", -1)
              ]))]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _createElementVNode("li", _hoisted_10, [
            _createVNode(_component_router_link, {
              to: "/devices",
              class: "nav-link",
              "active-class": "active",
              onClick: _ctx.closeMobileMenu
            }, {
              default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                _createElementVNode("svg", {
                  xmlns: "http://www.w3.org/2000/svg",
                  fill: "none",
                  viewBox: "0 0 24 24",
                  stroke: "currentColor",
                  class: "nav-icon"
                }, [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    d: "M9 3v2m6-2v2M9 19v2m6-2v2M5 9H3m2 6H3m18-6h-2m2 6h-2M7 19h10a2 2 0 002-2V7a2 2 0 00-2-2H7a2 2 0 00-2 2v10a2 2 0 002 2zM9 9h6v6H9V9z"
                  })
                ], -1),
                _createElementVNode("span", { class: "nav-text" }, "Devices", -1)
              ]))]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _createElementVNode("li", _hoisted_11, [
            _createVNode(_component_router_link, {
              to: "/advanced-dashboard",
              class: "nav-link",
              "active-class": "active",
              onClick: _ctx.closeMobileMenu
            }, {
              default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                _createElementVNode("svg", {
                  xmlns: "http://www.w3.org/2000/svg",
                  fill: "none",
                  viewBox: "0 0 24 24",
                  stroke: "currentColor",
                  class: "nav-icon"
                }, [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    d: "M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
                  })
                ], -1),
                _createElementVNode("span", { class: "nav-text" }, "Advanced Dashboard", -1)
              ]))]),
              _: 1
            }, 8, ["onClick"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("a", _hoisted_13, [
          _cache[8] || (_cache[8] = _createElementVNode("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            class: "external-icon"
          }, [
            _createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z"
            })
          ], -1)),
          (!_ctx.sidebarCollapsed)
            ? (_openBlock(), _createElementBlock("span", _hoisted_14, "Solution Builder"))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("a", _hoisted_15, [
          _cache[9] || (_cache[9] = _createElementVNode("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            class: "external-icon"
          }, [
            _createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z"
            })
          ], -1)),
          (!_ctx.sidebarCollapsed)
            ? (_openBlock(), _createElementBlock("span", _hoisted_16, "Home Challenge"))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createVNode(_component_user_profile_dropdown, { collapsed: _ctx.sidebarCollapsed }, null, 8, ["collapsed"])
      ])
    ], 2),
    _createElementVNode("button", {
      class: _normalizeClass(["mobile-toggle", { active: _ctx.mobileMenuOpen }]),
      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggleMobileMenu && _ctx.toggleMobileMenu(...args))),
      "aria-label": "Toggle navigation"
    }, [...(_cache[10] || (_cache[10] = [
      _createElementVNode("span", null, null, -1),
      _createElementVNode("span", null, null, -1),
      _createElementVNode("span", null, null, -1)
    ]))], 2)
  ]))
}